import {
  AppRoutes,
  BeneficiaryRoutes,
  DataCollectionRoutes,
  IncomeDocumentationRoutes,
  InsuranceRoutes,
  KycRoutes,
  NegotiationRoutes,
} from "../../enums/app-routes.ts";

export const enum Events {
  INIT = "init",
  ERROR_MONITOR = "error_monitor",
  E02_FUNNEL_VIEW = "funnel_view",
  E14_OFFER_SUMMARY = "offer-summary",
  E15_KYC = "kyc",
  E16_PURCHASE = "purchase",
}

export const StepNumbers: Record<string, number> = {
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.CONTACT_INFO}`]: 1,
  [AppRoutes.POL]: 1,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.PRIVACY_CONSENTS}`]: 2,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.PERSONAL_INFO}`]: 3,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.BIRTH}`]: 4,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.FISCAL_CODE}`]: 5,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.EMPLOYMENT}`]: 6,

  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.HIRING}`]: 7,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.COMPANY_INDUSTRY}`]: 8,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.COMPANY_SIZE}`]: 9,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.MONTHLY_INCOME}`]: 10,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.OTHER_INCOME_SOURCES}`]: 11,

  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.PENSIONER_INCOME}`]: 10,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.PENSIONER_OTHER_INCOME}`]: 11,

  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.VAT_NUMBER}`]: 7,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.GROSS_INCOME}`]: 11,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.SELF_OTHER_INCOME}`]: 12,

  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.ADDRESS}`]: 12,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.MARITAL_STATUS}`]: 13,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.FAMILY}`]: 14,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.LIVING_SITUATION}`]: 15,
  [`/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.COUPON_CODE}`]: 16,

  [`/${AppRoutes.NEGOTIATION}`]: 17,

  [`/${AppRoutes.INSURANCE}`]: 18,
  [`/${AppRoutes.INSURANCE}/${InsuranceRoutes.INFO}`]: 18,
  [`/${AppRoutes.INSURANCE}/${InsuranceRoutes.EXCLUSIONS}`]: 18,
  [`/${AppRoutes.INSURANCE}/${InsuranceRoutes.ADVANTAGES}`]: 18,

  [`/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.OFFER}`]: 19,
  [`/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.EDIT_OFFER}`]: 19,
  [`/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.BUREAU_KO}`]: 19,
  [`/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.DECLINED_BY_RULES}`]: 19,

  [`/${AppRoutes.INSURANCE}/${InsuranceRoutes.QUESTIONNAIRE}`]: 20,

  [`/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.IBAN}`]: 21,

  [`/${AppRoutes.INCOME_DOCUMENATION}/${IncomeDocumentationRoutes.PAYROLL}`]: 22,
  [`/${AppRoutes.INCOME_DOCUMENATION}/${IncomeDocumentationRoutes.ACCOUNT_STATEMENT}`]: 23,

  [`/${AppRoutes.INSURANCE}/${InsuranceRoutes.BENEFICIARY}`]: 24,
  [`/${AppRoutes.INSURANCE}/${InsuranceRoutes.BENEFICIARY}/${BeneficiaryRoutes.SELECT}`]: 24,

  [`/${AppRoutes.ADV}`]: 25,
  [`/${AppRoutes.ADV}/${AppRoutes.QUESTION}`]: 26,

  [`/${AppRoutes.KYC}`]: 27,
  [`/${AppRoutes.KYC}/${AppRoutes.IDENTIFICATION_IN_PROGRESS}`]: 28,
  [`/${AppRoutes.KYC}/${KycRoutes.COMPLETED}`]: 29,
};

export interface GenericDataLayer {
  event: Events;
}

// Error
export interface ErrorMonitor extends GenericDataLayer {
  error_type: string; //tipologia dell'errore
  error_code: string; //codice di errore
  error_line: string; //linea dove si è verificato l'errore // TODO: AxiosError has no info on line
  error_url: string; //url della pagina dove si è verificato l'errore
  error_module: string; //nome del modulo o libreria che è andato in errore // TODO: AxiosError has no info on modules
}

export interface InitDataLayer extends GenericDataLayer {
  user_id: string;
  is_logged: boolean;
}

export interface FunnelViewDataLayer extends GenericDataLayer {
  page_path: string;
  page_section: string;
  page_name: string;
  page_url: string;
  page_host: string;
  previous_page_path: string;
  previous_page_section: string;
  step_number?: number;
  step_name: string;
}

export interface OfferSummaryDataLayer extends FunnelViewDataLayer {
  progetto: string;
  importo: number;
  durata_mesi: number;
}

export type KycDataLayer = OfferSummaryDataLayer;

export interface PurchaseDataLayer extends OfferSummaryDataLayer {
  taeg: number;
  tan: number;
  rata_mensile: number;
  transactionId: string;
  currency: string;
  value: number;
  paymentType: string;
}
